import React from "react";
import { Box, Typography, Card, CardContent, Alert } from "@mui/material";
import { BarChart2 } from "lucide-react";

const AnalyticsPage: React.FC = () => (
  <Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: "1.6rem", sm: "2rem" } }}>
        Analytics
      </Typography>
    </Box>
    <Alert severity="info" sx={{ mb: 3 }}>
      Detailed analytics charts are available on the Dashboard page. This page will be expanded with deeper game-level analytics soon.
    </Alert>
    <Card>
      <CardContent sx={{ textAlign: "center", py: 6 }}>
        <Typography variant="h6" color="textSecondary">Coming Soon</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Game analytics, player retention, and revenue trends will appear here.
        </Typography>
      </CardContent>
    </Card>
  </Box>
);

export default AnalyticsPage;
